export default "__VITE_ASSET__COF0lWWQ__"